<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirmSelection($event)"
  data-test="import-cropfields"
>
  <div class="flex--row flex--gutter">
    <div class="flex__child--auto spacing--padding-all">
      {{ 'importCropFieldsExplanation' | translate }}
    </div>
  </div>

  <div class="flex--row flex--gutter">
    <button mat-button (click)="toggleSelection()">
      <mat-icon>select_all</mat-icon>
      {{ (areAllCropFieldSelected() ? 'deselectAll' : 'selectAll') | translate }}
    </button>
  </div>

  <div class="crop-field-filter--list">
    @for (
      item of getCropNamesFromSelectableCropFieldsWithCropFieldCounts() | keyvalue;
      track item
    ) {
      <div
        matRipple
        class="crop-field-filter--item grey-in-animation"
        (click)="toggleAllCropFieldsWithCropName(item.key)"
      >
        <span [title]="item.key" class="crop-field-filter--item-title">{{ item.key }}</span>
        <div class="crop-field-filter--item-count">
          <mat-checkbox
            disabled
            class="crop-field-filter--item-checkbox"
            [indeterminate]="
              -item.value < allCropFieldsOfCropTypeSelected(item.key, item.value) &&
              allCropFieldsOfCropTypeSelected(item.key, item.value) < 0
            "
            [checked]="allCropFieldsOfCropTypeSelected(item.key, item.value) === 0 ? true : false"
          >
          </mat-checkbox>
          <span>{{ item.value }}</span>
        </div>
      </div>
    }
  </div>

  <div class="flex--row flex--gutter">
    <mat-action-list class="flex__child--auto">
      @for (cropField of selectableCropFields; track cropField; let i = $index) {
        <button
          mat-list-item
          (click)="selectCropField(cropField)"
          [attr.data-test]="'crop-field--' + i"
        >
          <h2 matListItemTitle>
            <mat-icon>{{ cropField.isSelected ? 'check_box' : 'check_box_outline_blank' }}</mat-icon
            >{{ cropField.name }}
          </h2>
          <p matListItemTitle>
            {{ cropField.startDate | date: 'shortDate' }} -
            {{ cropField.endDate | date: 'shortDate' }}
          </p>
          <p matListItemTitle>{{ cropField.areaInHectares }} ha</p>
          <p matListItemTitle>
            {{ cropField.cropName }}
            {{ cropField.cropVarietyName ? ' (' + cropField.cropVarietyName + ')' : '' }}
          </p>
        </button>
      }
      @if (data.cropFields.length === 0) {
        <div class="notification notification-warning spacing--margin-horizontal">
          <mat-icon class="text-color--primary spacing--margin-right">warning</mat-icon
          >{{ 'noCropFieldsImported' | translate }}
        </div>
      }
    </mat-action-list>
  </div>
</agr-form-dialog>
